import component from './statistic.component';

let module = angular.module('statistic', [])
	.component('statistic', component)
	.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/statistic/statistic.js